import _ from 'lodash';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { ISelectedOption } from '../../../../../../../../../../../components/Select/configurations';
import { generalReducerValues } from '../../../../../../../../../../../General.reducer';
import { Select, ISelectProps, TSelectedOptions } from '../../../../../../../../../../../lib/esm/components';
import { getReportingObjects } from '../../../../../../../../../../../tools/getReportingObjects';
import { FormItem } from '../../styles';

const SelectObjectType: React.FC<
    ISelectProps & { selectedId: string; handleSelectValue: (selects: TSelectedOptions) => void }
> = ({ handleSelectValue, selectedId = '' }) => {
    const {
        cfg: { reportingObjectsByType },
    } = useSelector(generalReducerValues);
    const [selectedMetrics, setSelectedMetrics] = useState<TSelectedOptions>([]);
    const { t } = useTranslation();

    const options = useMemo(() => {
        return getReportingObjects(reportingObjectsByType, t).map((item) => ({
            id: item.key,
            text: t(item.section),
        }));
    }, [t]);

    const handleSelect = (args: TSelectedOptions) => {
        if (args.length) {
            setSelectedMetrics([args[0]]);
        }
        handleSelectValue(args);
    };

    const metricSelect = useMemo(() => {
        let outsideSelected: TSelectedOptions = [];

        const outsideSelect = options?.find((x: ISelectedOption) => x.id === selectedId);
        if (outsideSelect) {
            outsideSelected = [outsideSelect];
        } else if (!_.isEmpty(options)) {
            outsideSelected = [options[0]];
        }

        return (
            <Select
                options={options}
                showFilter={false}
                labelText={t('Show inside rating')}
                iconType={'chevron-down'}
                mode="single"
                shadow="md"
                handleSelect={handleSelect}
                outsideSelected={outsideSelected}
            />
        );
    }, [selectedMetrics, options, t, selectedId]);

    return <FormItem>{metricSelect}</FormItem>;
};
export default SelectObjectType;
